import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, Input } from '@angular/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject } from 'rxjs';
import { PricingService } from 'src/app/shared/pricing.service';
import { StepByStepService } from 'src/app/shared/step-by-step.service';

declare let getIntiaroPlayer: any;

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css'],
})
export class SummaryComponent implements OnInit, AfterViewChecked {

  @Input() productId = 0;
  @Input() showPricing = true;
  showPrice = new BehaviorSubject<boolean>(true);

  public faArrowLeft = faArrowLeft;
  public printButtonText = 'Download to print';
  public showButton: string = 'print';
  public urlToPdf = '';
  public price: number | undefined;
  private note: string = "";
  public showEmailModal = false;
  private flagNewNote = false;
  public showQuestionModal = false;
  private clickedEmail = false;
  private clickedPrint = false;
  private customerDecision = false;
  private subscription: any;
  public showLoader: boolean = true;

  private _player: any = false;
  public displayableProductConfiguration: any;
  private get player(): any {
    if (!this._player) {
      this._player = getIntiaroPlayer('Intiaro-configurator');
    }
    return this._player;
  }
  public printedAttributesWithChoices: any;

  constructor(
    private stepByStepService: StepByStepService,
    private cdr: ChangeDetectorRef,
    private pricingService: PricingService,

  ) {
    this.showPricing ? this.showPrice.next(true) : this.showPrice.next(false);
  }

  async ngOnInit() {
    this.price = this.stepByStepService.price;
  }

  async ngAfterViewInit() {
    this.player.getProductOptions(
      true,
      (options: any) => { this.printProductFinalOptions(options) },
      (err: any) => { console.log('Error: IntiaroPlayer.getProductOptions()', err) }
    )

    this.showLoader = false;
  }

  ngAfterViewChecked() {
    this.subscription = this.stepByStepService.getStatusCustomerRequest().subscribe(status => {
      this.customerDecision = status;
      if (status && this.clickedEmail) this.sendEmail();
      if (status && this.clickedPrint) this.print();
    })
    this.pricingService.checkPrice().subscribe(priceFromService => {
      this.price = priceFromService;
      (priceFromService == undefined || priceFromService == 0) ? this.showPrice.next(false) : this.showPrice.next(true);
    })
    this.cdr.detectChanges();
  }

  public saveNotes(event: any): void {
    let newNote = event.target.value;
    this.flagNewNote = true;
    if (newNote === this.note || newNote === '') {
      this.flagNewNote = false
    }
    this.note = newNote;
    this.stepByStepService.saveCommentFromSummary(this.note);
    this.stepByStepService.toggleStatusCustomerRequest(false);
  }

  public sendEmail(): void {
    if (this.flagNewNote && !this.customerDecision) {
      this.showQuestionModal = true;
      this.clickedEmail = true;
      this.clickedPrint = false;
    } else {
      this.showEmailModal = true;
      this.flagNewNote = false;
    };
  }

  public print(): void {
    if (this.flagNewNote && !this.customerDecision) {
      this.showQuestionModal = true;
      this.clickedPrint = true;
      this.clickedEmail = false;
    } else {
      this.showButton = 'loader';
      this.player.getProductSummaryUrl(
        [40, 120, 230],
        (url: any) => {
          this.showButton = 'download';
          this.urlToPdf = url;
          window.location.href = url;
          console.log('Printing:', url);
        },
        () => {
          this.showButton = 'print';
          this.printButtonText = 'No PDF to print';
          console.log('No pdf to print');
        }
      );

      this.flagNewNote = false;
      this.subscription.unsubscribe();
      this.stepByStepService.toggleStatusCustomerRequest(false)
    };
  }

  public closeModal(close: boolean): void {
    this.subscription.unsubscribe();
    if (close) {
      let statusFromService = this.customerDecision
      statusFromService && (this.stepByStepService.toggleStatusCustomerRequest(false));
      this.showEmailModal = false;
      this.showQuestionModal = false;
    }
  }

  public closeSummary(): void {
    this.stepByStepService.toggleStatusSummary(false)
  }

  public printProductFinalOptions(options: any) {
    let attributesWithChoices: { [key: string]: string } = {};
    options.elements.forEach((element: any) => {
      element.attributes.forEach((attribute: any) => {
        attributesWithChoices[attribute.name] ? '' : attributesWithChoices[attribute.name] = attribute.choice.name
      })
    })
    this.printedAttributesWithChoices = attributesWithChoices
  }
}
